import { useState, useEffect, useRef } from 'react';
import './styles.scss';
import { useStore } from 'src/onboarding/store/store';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { t } from '@web-solutions/module-localization';
import getLocale from 'src/localization/get-locale';

const STORAGE_KEY = 'photo_progress';

export const PhotoProgress = () => {
  const [animatedProgress, setAnimatedProgress] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? parseFloat(saved) : 0;
  });
  const locale = getLocale();

  const photoProcessingUuid = useStore((state) => state.photoProcessingUuid);
  const imageUrl = useStore((state) => state.imageUrl);
  const progressRef = useRef(animatedProgress);
  const intervalRef = useRef(null);
  const currentPage = useStore((state) => state.currentPage);
  const { routeGroups: groups, showFaceScan, ltsPhotoExample } = useRemoteConfig();
  const allRoutes = groups.flat();
  const setShowPhotoProcessing = useStore((state) => state.setShowPhotoProcessing);

  const startIndex = allRoutes.findIndex((el) => el === 'lts-photo-example');
  const firstStepIndex = showFaceScan ? startIndex : startIndex + 1;
  const resultIndex = allRoutes.findIndex((el) => el === 'lts-result');
  const currentIndex = allRoutes.findIndex((el) => el === currentPage);

  const isResultPage = currentIndex === resultIndex;

  const isPersonalPlanPage =
    currentPage === 'personal-plan-dynamic' || currentPage === 'test-personal-plan';

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    const savedProgress = parseFloat(localStorage.getItem(STORAGE_KEY) || '0');

    if (currentIndex === firstStepIndex) {
      progressRef.current = 0;
      setAnimatedProgress(0);
      localStorage.setItem(STORAGE_KEY, '0');
    } else if (isResultPage) {
      progressRef.current = 100;
      setAnimatedProgress(100);
      localStorage.setItem(STORAGE_KEY, '100');
      return;
    }

    // else if (generatedPhotoUrl) {
    //   progressRef.current = 99;
    //   setAnimatedProgress(99);
    //   localStorage.setItem(STORAGE_KEY, '99');
    //   return;
    // }

    if (savedProgress > progressRef.current) {
      progressRef.current = savedProgress;
      setAnimatedProgress(savedProgress);
    }

    intervalRef.current = setInterval(() => {
      if (progressRef.current < 99) {
        progressRef.current += 1;
        const clamped = Math.min(progressRef.current, 99);
        setAnimatedProgress(clamped);
        localStorage.setItem(STORAGE_KEY, clamped.toFixed(2));
      } else {
        clearInterval(intervalRef.current);
      }
    }, 800);

    return () => clearInterval(intervalRef.current);
  }, [currentPage]);

  if (
    // !photoProcessingUuid ||
    currentIndex < startIndex ||
    isPersonalPlanPage
  ) {
    setShowPhotoProcessing(false);
    return null;
  }

  return (
    <div className='photo-progress-wrapper'>
      <div className='photo-progress'>
        {showFaceScan && (
          <div className='photo-progress-scan'>
            <img className='photo' src={imageUrl} alt='user' />
            <div className='photo-progress-scan-line' />
          </div>
        )}
        <div className='photo-progress-content'>
          <div className='progress-line'>
            <span style={{ width: `${animatedProgress}%`, transition: 'width 0.4s linear' }}></span>
          </div>
          {/* <div className='progress-info'> */}
          {/* {currentPage === 'lts-photo-example'
              ? t('onboarding.photo-progress.minutes')
              : t('onboarding.photo-progress.goalProgress', { percent: Math.round(animatedProgress)})
              } */}

          {/* </div> */}
          <div className='progress-info'>
            {`${ltsPhotoExample.photoProgressTitle[locale]} ${Math.round(animatedProgress)}%`}
          </div>
        </div>
      </div>
    </div>
  );
};
